/**
 * Created by wangqian on 2017/5/12.
 */


if(navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion .split(";")[1].replace(/[ ]/g,"")=="MSIE8.0") {

  var bannerBar = {
    //默认参数
    _options: {
      //banner最外层dom的id，例如banner_container
      container: '',
      //轮播dom的id，例如['item1','item2']
      bannerItems: [],
      //轮播间隔时长，默认2000毫秒
      autoPlayTime: 2000,
    },
    //轮播圆圈的数组
    _circleTabs: [],
    //当前页面对应的圆圈数组id
    _currentTab: 0,
    //是否结束动画
    _endCircle: false,
    //s1:传入参数，开始整个流程
    init: function (options) {
      $.extend(this._options, options);

      this.insertDOM();
      this.bindEvent();
      this.createCircle();
      // this.startTab();
    },
    //s2:插入dom
    insertDOM: function () {
      var self = this,
        $container = $('#' + self._options.container),
        tabDoms = [];

      tabDoms.push('<div class="dd-banner-tab">');
      tabDoms.push('  <span class="slide prev"><i class="iconfont-dinghome201705" style="font-size: 42px">&#xe6c1;</i></span>');
      tabDoms.push('  <span class="slide next"><i class="iconfont-dinghome201705" style="font-size: 42px">&#xe6c2;</i></span>');
      tabDoms.push('  <ul class="tab-ul" id="banner_tab_ul">');
      for (var i = 0; i < self._options.bannerItems.length; i++) {
        tabDoms.push('<li class="tab-li" id="tab-' + i + '"></li>');
      }
      tabDoms.push('  </ul>');
      tabDoms.push('</div>');

      $container.append(tabDoms.join(''));
    },

    //s3:绑定dom点击事件
    bindEvent: function () {
      var self = this;

      //单个轮播圆圈的点击事件
      $('.dd-banner-tab .tab-li').each(function () {
        var selectTab = $(this).attr('id').split('-')[1] - 0;
        $(this).click(function () {

          if (parseInt(selectTab) > parseInt(self._currentTab)) {
            self.showBannerItem(self._currentTab, selectTab, 'next');
          } else if (parseInt(selectTab) < parseInt(self._currentTab)) {
            self.showBannerItem(self._currentTab, selectTab, 'prev');
          }
          self._currentTab = selectTab;
        })
      });

      //下一页点击事件
      $('.dd-banner-tab .next').click(function () {
        self.stopTab();
        if (self._circleTabs.length == 1) {
          return;
        }
        var nextIndex;

        if (self._currentTab - 0 == self._circleTabs.length - 1) {
          nextIndex = 0;
          self.showBannerItem(self._currentTab, 0, 'prev');
        } else {
          nextIndex = self._currentTab - 0 + 1;
          self.showBannerItem(self._currentTab, self._currentTab - 0 + 1, 'next');
        }

        self._currentTab = nextIndex;
      });

      //上一页点击事件
      $('.dd-banner-tab .prev').click(function () {
        self.stopTab();
        if (self._circleTabs.length == 1) {
          return;
        }
        var nextIndex;

        if (self._currentTab - 0 === 0) {
          nextIndex = self._circleTabs.length - 1;
          self.showBannerItem(self._currentTab, self._circleTabs.length - 1, 'next');
        } else {
          nextIndex = self._currentTab - 0 - 1;
          self.showBannerItem(self._currentTab, self._currentTab - 0 - 1, 'prev');
        }

        self._currentTab = nextIndex;
      });
    },
    //s4:使用processbar.js形成circle
    createCircle: function () {
      var self = this;
      $('#banner_tab_ul').find('li').each(function (index, item) {
        self._circleTabs.push(index);
      });

      //设置bannerItem隐藏
      for (var i = 0; i < self._options.bannerItems.length; i++) {
        $('#' + self._options.bannerItems[i]).addClass('dd-item-hide');
      }
      $('#' + self._options.bannerItems[0]).addClass('dd-item-show');
    },

    //轮播当前结束，选取下一个
    nextTab: function () {
      var self = this, nextIndex;

      if (self._currentTab - 0 == self._circleTabs.length - 1) {
        nextIndex = 0;
        // self.showBannerItem(self._currentTab, 0, 'prev');
        self.showBannerItem(self._currentTab, 0, 'next');
      } else {
        nextIndex = self._currentTab - 0 + 1;
        self.showBannerItem(self._currentTab, self._currentTab - 0 + 1, 'next');
      }

      self._currentTab = nextIndex;
      self.startTab();
    },


    //bannerItem切换的效果
    showBannerItem: function (current, next) {
      var self = this,
        currentItemId = self._options.bannerItems[current],
        nextItemId = self._options.bannerItems[next],
        $currentItem = $('#' + currentItemId),
        $nextItem = $('#' + nextItemId);

      $currentItem.css('visibility','hidden');
      $nextItem.css('visibility','visible');

    },

    //点击停止轮播
    stopTab: function () {
      var self = this;
      self._endCircle = true;
    }

  };
}else {
  var ProgressBar = require('./libs/progressbar');

  var bannerBar = {
    //默认参数
    _options: {
      //banner最外层dom的id，例如banner_container
      container: '',
      //轮播dom的id，例如['item1','item2']
      bannerItems: [],
      //轮播间隔时长，默认2000毫秒
      autoPlayTime: 2000,
    },
    //轮播圆圈的数组
    _circleTabs: [],
    //当前页面对应的圆圈数组id
    _currentTab: 0,
    //是否结束动画
    _endCircle: false,
    //s1:传入参数，开始整个流程
    init: function (options) {
      $.extend(this._options, options);

      this.insertDOM();
      this.bindEvent();
      this.createCircle();
      this.startTab();
    },
    //s2:插入dom
    insertDOM: function () {
      var self = this,
        $container = $('#' + self._options.container),
        tabDoms = [];

      tabDoms.push('<div class="dd-banner-tab">');
      tabDoms.push('  <span class="slide prev"><i class="iconfont-dinghome201705" style="font-size: 42px">&#xe6c1;</i></span>');
      tabDoms.push('  <span class="slide next"><i class="iconfont-dinghome201705" style="font-size: 42px">&#xe6c2;</i></span>');
      tabDoms.push('  <ul class="tab-ul" id="banner_tab_ul">');
      for (var i = 0; i < self._options.bannerItems.length; i++) {
        tabDoms.push('<li class="tab-li" id="tab-' + i + '"></li>');
      }
      tabDoms.push('  </ul>');
      tabDoms.push('</div>');

      $container.append(tabDoms.join(''));
    },

    //s3:绑定dom点击事件
    bindEvent: function () {
      var self = this;

      //单个轮播圆圈的点击事件
      $('.dd-banner-tab .tab-li').each(function () {
        var selectTab = $(this).attr('id').split('-')[1] - 0;
        $(this).click(function () {
          self.stopTab();
          self._circleTabs[self._currentTab].set(0);
          self._circleTabs[selectTab].set(1);

          if (parseInt(selectTab) > parseInt(self._currentTab)) {
            self.showBannerItem(self._currentTab, selectTab, 'next');
          } else if (parseInt(selectTab) < parseInt(self._currentTab)) {
            self.showBannerItem(self._currentTab, selectTab, 'prev');
          }
          self._currentTab = selectTab;
        })
      });

      //下一页点击事件
      $('.dd-banner-tab .next').click(function () {
        self.stopTab();
        if (self._circleTabs.length == 1) {
          return;
        }
        var nextIndex;
        self._circleTabs[self._currentTab].set(0);

        if (self._currentTab - 0 == self._circleTabs.length - 1) {
          nextIndex = 0;
          // self.showBannerItem(self._currentTab, 0, 'prev');
          self.showBannerItem(self._currentTab, 0, 'next');
        } else {
          nextIndex = self._currentTab - 0 + 1;
          self.showBannerItem(self._currentTab, self._currentTab - 0 + 1, 'next');
        }

        self._circleTabs[nextIndex].set(1);
        self._currentTab = nextIndex;
      });

      //上一页点击事件
      $('.dd-banner-tab .prev').click(function () {
        self.stopTab();
        if (self._circleTabs.length == 1) {
          return;
        }
        var nextIndex;
        self._circleTabs[self._currentTab].set(0);

        if (self._currentTab - 0 === 0) {
          nextIndex = self._circleTabs.length - 1;
          // self.showBannerItem(self._currentTab, self._circleTabs.length - 1, 'next');
          self.showBannerItem(self._currentTab, self._circleTabs.length - 1, 'prev');
        } else {
          nextIndex = self._currentTab - 0 - 1;
          self.showBannerItem(self._currentTab, self._currentTab - 0 - 1, 'prev');
        }

        self._circleTabs[nextIndex].set(1);
        self._currentTab = nextIndex;
      });
    },
    //s4:使用processbar.js形成circle
    createCircle: function () {
      var self = this;
      $('#banner_tab_ul').find('li').each(function (index, item) {
        var bar = new ProgressBar.Circle(item, {
          strokeWidth: 10,
          easing: 'linear',
          duration: self._options.autoPlayTime,
          color: '#3296fa',
          trailColor: 'rgba(255,255,255,0.2)',
          trailWidth: 10,
          svgStyle: null
        });
        self._circleTabs.push(bar);
      });

      //设置bannerItem隐藏
      for (var i = 0; i < self._options.bannerItems.length; i++) {
        $('#' + self._options.bannerItems[i]).addClass('dd-item-hide');
      }
      $('#' + self._options.bannerItems[0]).addClass('dd-item-show');
    },
    //s5:定位第一个item，开始倒计时,轮播开始
    startTab: function () {
      var self = this;
      if (self._circleTabs.length == 1) {
        self._circleTabs[0].set(1);
        return;
      }
      self._circleTabs[self._currentTab].set(0);
      self._circleTabs[self._currentTab].animate(1, {
        duration: self._options.autoPlayTime
      }, function () {
        if (!self._endCircle) {
          self.nextTab();
        }
      })
    },

    //轮播当前结束，选取下一个
    nextTab: function () {
      var self = this, nextIndex;
      self._circleTabs[self._currentTab].set(0);

      if (self._currentTab - 0 == self._circleTabs.length - 1) {
        nextIndex = 0;
        self.showBannerItem(self._currentTab, 0, 'prev');
      } else {
        nextIndex = self._currentTab - 0 + 1;
        self.showBannerItem(self._currentTab, self._currentTab - 0 + 1, 'next');
      }

      self._currentTab = nextIndex;
      self.startTab();
    },


    //bannerItem切换的效果
    showBannerItem: function (current, next, type) {
      var self = this,
        currentItemId = self._options.bannerItems[current],
        nextItemId = self._options.bannerItems[next],
        inClass = type === 'next' ? 'dd-item-moveFromRight' : 'dd-item-moveFromLeft',
        outClass = type === 'next' ? 'dd-item-moveToLeft' : 'dd-item-moveToRight',
        $currentItem = $('#' + currentItemId),
        $nextItem = $('#' + nextItemId);

      $currentItem.addClass(outClass).addClass('dd-item-show');
      $nextItem.addClass(inClass).addClass('dd-item-show');
      setTimeout(function () {
        self.endAnimation($currentItem, $nextItem, inClass, outClass);
      }, 610);

    },
    //结束滑动，去掉css对应的class，动画结束置为false
    endAnimation: function ($currentItem, $nextItem, inClass, outClass) {
      $currentItem.removeClass(outClass).removeClass('dd-item-show');
      $nextItem.removeClass(inClass);
    },

    //点击停止轮播
    stopTab: function () {
      var self = this;
      self._endCircle = true;
    }

  };
}



window.__BannerBar = bannerBar;


//////////////////
// WEBPACK FOOTER
// ./app/js/bannerTab.page.js
// module id = 0
// module chunks = 0